import React, { Component } from 'react'
import { connect } from 'react-redux'
import { req_single_cms_school_student, req_single_cms_learnmap_yearplan, req_single_cms_learnmap_talent_tab, req_single_cms_learnmap_completed_ability } from '../../api'
import { Tabs, Card, Table, Alert, Tag, Divider } from 'antd'
import { getNowAcademicYear, getNowAcademicSemester } from '../../utils/dateUtil'

const { TabPane } = Tabs
class CoursemapStudentCompletedAbility extends Component {
    // 基礎通用參數 //////////////////////////////////////////////  
    state = {
        items: [],
        deviceWidth: 0,
        loading: false,
        nowAcademicYear: getNowAcademicYear(new Date()),
        nowAcademicSemester: getNowAcademicSemester(new Date()),
        talents: [],
        activity: [],
        defaultKey: null
    }

    componentDidMount() {
        window.addEventListener('resize', this.resize.bind(this))
        this.resize()
        this.api_init_items()
    }

    // componentWillUnmount() {
    //     window.removeEventListener("resize", this.resize.bind(this))
    // }

    resize() {
        this.setState({ deviceWidth: window.innerWidth });
    }

    // 遠端數據處理 //////////////////////////////////////////////
    api_init_items = async () => {
        const { userCode, token } = this.props.user
        this.setState({ loading: true, items: [] })

        const result = await req_single_cms_school_student(userCode, token)
        if (result) {
            const { nowAcademicYear, nowAcademicSemester } = this.state
            const { enrollmnetYear, studentId, departmentInsideCode } = result
            let grade = nowAcademicYear - enrollmnetYear
            let semester = 1
            if (nowAcademicSemester === '2') {
                grade = grade + 1
                semester = nowAcademicSemester - 1
            }
            else {
                if (grade === 0) {
                    //一年級上學期
                    grade = 1
                    semester = 1
                }
                else {
                    semester = 2
                }
            }
            const showGradeSemester = grade.toString() + semester.toString()

            const yearplan = await req_single_cms_learnmap_yearplan(result, token)
            if (yearplan) {
                const tab = await req_single_cms_learnmap_talent_tab(userCode, token)
                if (tab) {
                    if (tab.total > 0) {
                        const talents = tab.data
                        const defaultKey = talents[0].nidTalent
                        this.setState({ talents, defaultKey })

                        const record = {
                            gidLearnMapMeta: yearplan.gidLearnMapMeta,
                            nidLearnMapMeta: yearplan.nidLearnMapMeta,
                            studentId: studentId,
                            department: departmentInsideCode,
                            enrollmnetYear: enrollmnetYear,
                            gradeSemester: showGradeSemester,
                        }
                        const completedtalents = await req_single_cms_learnmap_completed_ability(record, token)
    
                        if (completedtalents) {
                            if (completedtalents.total > 0) {
                                const items = completedtalents.data
                                this.activities = items
                                this.setState({ items })
                                //console.log(items)
                            }
                        }

                        this.tab_change(defaultKey)
                        this.setState({ loading: false })
                    }
                } else {
                    this.setState({ loading: false })
                }
            } else {
                this.setState({ loading: false })
            }
        } else {
            this.setState({ loading: false })
        }
    }

    // 數據配置處理 //////////////////////////////////////////////

    groupBy = (xs, key) => {
        return xs.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x)
            return rv;
        }, {})
    }

    set_label_text = (key, value) => {
        let text = ''
        switch (key) {
            case 'ABILITY':
                switch (value) {
                    case 'COMMON':
                        text = '基本素養'
                        break
                    case 'PROFESSION':
                        text = '核心能力'
                        break
                    default:
                }
                break
            default:
        }
        return text
    }

    set_label_color = (key, value) => {
        let color = 'black'
        switch (key) {
            case 'ABILITY':
                switch (value) {
                    case 'COMMON':
                        color = 'green'
                        break
                    case 'PROFESSION':
                        color = 'volcano'
                        break
                    default:
                }
                break
            default:
        }
        return color
    }

    // 介面互動處理 //////////////////////////////////////////////

    tab_change = async (key) => {
        // const { items } = this.state
        // console.log(key)
        this.setState({ activity: [] })
        this.activity = this.activities.filter(function (e) {
            return e.nidTalent.toString() === key.toString()
        })
        this.setState({ activity: this.activity })
        //console.log(this.activity)
    }

    /////////////////////////////////////////////////////////////  
    render() {
        const { loading, defaultKey, deviceWidth, talents } = this.state
        const columns = [
            {
                title: '能力屬性',
                width: 60,
                responsive: ['md'],
                render: (item) => {
                    const { abilityCategoryCode } = item
                    return (
                        <div className='text-center'>
                            <Tag color={this.set_label_color('ABILITY', abilityCategoryCode)}><i className={abilityCategoryCode === 'PROFESSION' ? 'fa fa-podcast' : 'fas fa-street-view'}></i>  {this.set_label_text('ABILITY', abilityCategoryCode)}</Tag>
                        </div>
                    )
                },

            },
            {
                title: '完成度',
                width: 40,
                render: (item) => {
                    const { talentValueMe } = item
                    return (
                        <span>{(Math.sqrt(talentValueMe) * 10).toFixed(2)}%</span>
                    )
                },
                responsive: ['md'],
            },
            {
                title: '百分等級(PR)值',
                width: 60,
                render: (item) => {
                    const { abilityPRValue, rankPRValue, studentTotal } = item
                    return (
                        <span>{abilityPRValue}%，(排名：第{rankPRValue}名，共{studentTotal}人)</span>
                    )
                },
            },
        ]
        const tabPanes = talents.length > 0 ? talents.map((row, idx) => <TabPane tab={row.talentTwName} key={row.nidTalent}>
            <Alert
                key={idx}
                description={row.talentDescription}
                type="success"
                showIcon
            />
            <Alert key={idx} message="註：PR（又稱為百分等級）值，是先將該次測驗所有學生的量尺總分排序後，依照人數均分成一百等分，該學生大約會落在第幾個等分中。 簡單來說，若某位學生的PR值為90， 即表示該生的分數高於該次測驗全數約90%學生" type="info" />
            <Table
                bordered
                style={{ width: '100%' }}
                scroll={{ y: 500 }}
                loading={loading}
                rowKey='abilityValueMe'
                dataSource={this.activity}
                pagination={false}
                columns={columns}
            />
        </TabPane>
        ) : ''

        const htmlItems = this.activities ? (<>
            {deviceWidth > 800 ? (
                <Card>
                    <Tabs defaultActiveKey={defaultKey} onChange={this.tab_change}>
                        {tabPanes}
                    </Tabs>
                </Card>) : (<div className="row" >
                    <div className="col-sm" style={{ marginTop: '5px' }}>
                        <Alert message="註：PR（又稱為百分等級）值，是先將該次測驗所有學生的量尺總分排序後，依照人數均分成一百等分，該學生大約會落在第幾個等分中。 簡單來說，若某位學生的PR值為90， 即表示該生的分數高於該次測驗全數約90%學生" type="success" />
                    </div>
                    {this.activities.map((row, idt) => <>
                        <div className="col-sm" style={{ marginTop: '5px' }}>
                            <Card
                                key={idt}
                                title={<><i className="fas fa-universal-access"></i> {row.talentTwName}</>}
                                style={{ backgroundColor: 'rgba(255, 255, 255, 0.0)', border: 0 }}
                                headStyle={{ backgroundColor: 'rgba(75, 28, 90, 0.4)', border: 0 }}
                                bodyStyle={{ backgroundColor: 'rgba(248, 225, 255, 0.4)', border: 0 }}
                            >
                                <div><Tag color="magenta" key={idt}>屬性</Tag><Tag color={row.abilityCategoryCode === 'COMMON' ? '#87d068' : '#f50'}><i className={row.abilityCategoryCode === 'PROFESSION' ? 'fa fa-podcast' : 'fas fa-street-view'}></i>  {row.abilityCategoryCode === 'COMMON' ? '基本素養' : '核心能力'}</Tag></div>
                                <p />
                                <div><Tag color="magenta" key={idt}>完成度</Tag><span style={{ color: 'Blue' }}>{(Math.sqrt(row.talentValueMe) * 10).toFixed(2)}%</span></div>
                                <p />
                                <div><Tag color="magenta" key={idt}>PR值</Tag><span style={{ color: 'Blue' }}>{row.abilityPRValue}%，(排名：第{row.rankPRValue}名，共{row.studentTotal}人)</span></div>
                                <Divider orientation="left" plain key={idt}>
                                    人才描述
                                </Divider>
                                {row.talentDescription}
                            </Card>
                        </div>

                    </>)}
                </div>)}

        </>) : (<Alert
            message="無相關資訊(此功能僅適用日四技查詢)"
            type="warning"
            closable
        />)

        return (
            <> {loading ? (<div className='text-center'>
                <p />
                <button className="btn " type="button" disabled>
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: '4px' }}></span>
                    Loading...
                </button>
            </div>) : (<>
                {htmlItems}
            </>)}</>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(CoursemapStudentCompletedAbility)